import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import usePost from "../../../Hooks/usePost";

function Webinar({ eventDetails, token, eventID }) {
  // Registration state and logic as provided
  const [inputs, setInputs] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const { status, execute, pending } = usePost();
  const navigate = useNavigate();

  // Mock external variables for the provided logic
  const firstName = "";
  const lastName = "";
  const email = "";
  const phone = "";
  const formContent = [];

  // Mock execute function for demonstration
  //   const execute = (endpoint, data, method, successMessage, errorCallback) => {
  //     console.log('Registration Data:', data);
  //     setIsSubmitting(false);
  //     setSubmitSuccess(true);
  //     alert(successMessage);
  //   };

  useEffect(() => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      ...(firstName && { firstName }),
      ...(lastName && { lastName }),
      ...(email && { email }),
      ...(phone && { phoneNumber: phone }),
    }));
  }, [firstName, lastName, email, phone]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handlePhoneChange = (value) => {
    setInputs((prevInputs) => ({ ...prevInputs, phoneNumber: value }));
    setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: "" }));
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setErrors((prevErrors) => ({ ...prevErrors, checkbox: "" }));
  };

  const handleRegister = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    let isValid = true;
    const newErrors = {};

    if (!inputs.firstName) {
      newErrors.firstName = "First name is required.";
      isValid = false;
    }
    if (!inputs.lastName) {
      newErrors.lastName = "Last name is required.";
      isValid = false;
    }
    if (!inputs.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required.";
      isValid = false;
    } else {
      const phoneNumberRegex = /^\+27\d{9}$/;
      if (!phoneNumberRegex.test(inputs.phoneNumber)) {
        newErrors.phoneNumber = "Phone number must be in format +27xxxxxxxxx";
        isValid = false;
      }
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!inputs.email) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (!emailRegex.test(inputs.email)) {
      newErrors.email = "Please enter a valid email.";
      isValid = false;
    }

    if (!isChecked) {
      newErrors.checkbox = "You must agree to the terms and conditions.";
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) {
      setIsSubmitting(false);
      return;
    }

    const customFields = formContent.slice(4)?.map((field) => ({
      label: field.label,
      value: inputs[field.name] || "",
    }));

    const registrationData = {
      firstName: inputs.firstName,
      lastName: inputs.lastName,
      email: inputs.email,
      phoneNumber: inputs.phoneNumber,
      customFields: customFields,
      communicationConsent: true, // Always true for now
    };

    execute(
      `attendees/add/${eventID}`,
      JSON.stringify(registrationData),
      "POST",
      "Successfully Registered. Please check your email for event entrance details",
      null,
      true,
      true
    );
  };

  useEffect(() => {
    if (status === "success") {
      // Redirecting to the full URL
      window.location.replace("https://kago.digital");
    }
  }, [status]);

  // useEffect(() => {
  //   if (status === "success") {
  //     if (eventDetails.redirect) {
  //       window.location.href = `${eventDetails.redirect}`;
  //     }
  //     if (!eventDetails.redirect) {
  //       navigate(`/Patient-Safety:-Advancing-Vitiligo-Care/p/event-landing/${eventID}`);
  //     }
  //   }
  // }, [status]);

  const heroStyles = {
    position: "relative",
    width: "100%",
    height: "90vh",
    minHeight: "500px",
    backgroundImage:
      "url(https://storage.googleapis.com/event-kago-nodejs.appspot.com/Images/bannerImage/bannerImage-1759741840960.jpeg?GoogleAccessId=firebase-adminsdk-pn0ly%40event-kago-nodejs.iam.gserviceaccount.com&Expires=1898553600&Signature=As%2F7hqtAG%2B3%2BBJtLr71TMMR87%2BXgBaCquAOdYVJXflmlmowS6G8lzDm3kOTPriWLBmjW435BiepNMVeLCspJ3pLGNE3euseoJNbo8DoNp3KoIykbKYQ9O35f8Ic9a1u9kIUs8zLNi8q3YmSzSXhQsDBQLu9L5SwuWQvhR58NQ5hWIgIar6%2FKRpH7E4zOQUjbpZxepiUCISR3yRGXUJcaqZ8FL2dXxfRcQB4bPGN8WBPDlIxbt%2BEQXnykclFzY2rmlqsH8DdKX0SUbZ1T%2BUdptlVfFqBjx73ooc4EOy77awzc6%2BJIGd0OLLYEXo%2FbdumeF%2Flv2HLaqeyIX3u1AuJw8g%3D%3D)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const overlayStyles = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const heroContentStyles = {
    textAlign: "center",
    color: "white",
    maxWidth: "800px",
    padding: "0 20px",
    zIndex: 1,
  };

  const ctaButtonStyles = {
    backgroundColor: "#f6891d",
    color: "white",
    border: "none",
    padding: "16px 32px",
    fontSize: "18px",
    fontWeight: "bold",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: "20px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(0, 123, 255, 0.3)",
  };

  const sectionStyles = {
    padding: "80px 20px",
    maxWidth: "1200px",
    margin: "0 auto",
  };

  const containerStyles = {
    display: "grid",
    gridTemplateColumns: window.innerWidth > 768 ? "1fr 1fr" : "1fr",
    gap: "60px",
    alignItems: "start",
  };

  const formStyles = {
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e1e5e9",
  };

  const inputStyles = {
    width: "100%",
    padding: "14px 16px",
    border: "2px solid #e1e5e9",
    borderRadius: "8px",
    fontSize: "16px",
    marginBottom: "8px",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
  };

  const inputFocusStyles = {
    ...inputStyles,
    borderColor: "#f6891d",
    outline: "none",
    boxShadow: "0 0 0 3px rgba(0, 123, 255, 0.1)",
  };

  const errorStyles = {
    color: "#dc3545",
    fontSize: "14px",
    marginBottom: "16px",
    display: "block",
  };

  const checkboxContainerStyles = {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "24px",
    fontSize: "14px",
    lineHeight: "1.5",
  };

  const submitButtonStyles = {
    backgroundColor: isSubmitting ? "#6c757d" : "#28a745",
    color: "white",
    border: "none",
    padding: "16px 32px",
    fontSize: "18px",
    fontWeight: "bold",
    borderRadius: "8px",
    cursor: isSubmitting ? "not-allowed" : "pointer",
    width: "100%",
    transition: "all 0.3s ease",
    opacity: isSubmitting ? 0.7 : 1,
  };

  const scrollToForm = () => {
    document.getElementById("registration-form").scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div
      style={{
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      {/* Hero Section */}
      <section style={heroStyles}>
        <div style={overlayStyles}>
          <div style={heroContentStyles}>
            {/* <h1 style={{ 
              fontSize: window.innerWidth > 768 ? '3.5rem' : '2.5rem', 
              fontWeight: 'bold', 
              marginBottom: '20px',
              lineHeight: '1.2'
            }}>
              Transform Your Business with Digital Innovation
            </h1>
            <p style={{ 
              fontSize: '1.3rem', 
              marginBottom: '30px',
              opacity: '0.95'
            }}>
              Join industry leaders for an exclusive webinar on cutting-edge strategies that drive growth
            </p> */}
            <button
              style={ctaButtonStyles}
              onClick={scrollToForm}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#0056b3";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#f6891d";
                e.target.style.transform = "translateY(0)";
              }}
            >
              Register Now - Free
            </button>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          {/* Webinar Info */}
          <div>
            <h2
              style={{
                fontSize: "2.5rem",
                fontWeight: "bold",
                marginBottom: "30px",
                color: "#2c3e50",
              }}
            >
              Webinar Details
            </h2>

            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "30px",
                borderRadius: "12px",
                marginBottom: "30px",
                borderLeft: "5px solid #f6891d",
              }}
            >
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "15px",
                  color: "#495057",
                }}
              >
                Event Information
              </h3>
              <p style={{ fontSize: "1.1rem", margin: "8px 0" }}>
                <strong>Date:</strong> October 18, 2025
              </p>
              <p style={{ fontSize: "1.1rem", margin: "8px 0" }}>
                <strong>Time:</strong> 10:00 AM - 12:00 PM (SAST)
              </p>
              <p style={{ fontSize: "1.1rem", margin: "8px 0" }}>
                <strong>Duration:</strong> 120 minutes
              </p>
              <p style={{ fontSize: "1.1rem", margin: "8px 0" }}>
                <strong>Format:</strong> Live Online Webinar
              </p>
            </div>

            <div
              style={{
                backgroundColor: "#fff3cd",
                padding: "25px",
                borderRadius: "12px",
                marginBottom: "30px",
                border: "1px solid #ffeaa7",
              }}
            >
              <h3
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "600",
                  marginBottom: "15px",
                  color: "#856404",
                }}
              >
                What You'll Learn
              </h3>
              <ul style={{ paddingLeft: "20px", fontSize: "1.1rem" }}>
                <li style={{ marginBottom: "8px" }}>
                  - The latest advancements in vitiligo diagnosis and treatment
                </li>
                <li style={{ marginBottom: "8px" }}>
                  - Best practices for improving patient safety and care
                  outcomes
                </li>
                <li style={{ marginBottom: "8px" }}>
                  - How to integrate digital tools into vitiligo care workflows
                </li>
                <li style={{ marginBottom: "8px" }}>
                  - Case studies on patient-centered approaches to treatment
                </li>
                <li style={{ marginBottom: "8px" }}>
                  - Interactive Q&A with dermatology and patient safety experts
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: "#e7f3ff",
                padding: "25px",
                borderRadius: "12px",
                border: "1px solid #b8e0ff",
              }}
            >
              <h3
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "600",
                  marginBottom: "15px",
                  color: "#0c5aa6",
                }}
              >
                Featured Speakers
              </h3>
              <p
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                Gaone Matewa
              </p>
              <p
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                Carol Banza
              </p>
              {/* <p style={{ fontSize: '1rem', color: '#6c757d' }}>
                Digital Transformation Consultant | Former VP of Innovation at TechCorp
              </p> */}
            </div>
          </div>

          {/* Registration Form */}
          <div>
            <form
              id="registration-form"
              style={formStyles}
              onSubmit={handleRegister}
            >
              <h2
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  marginBottom: "30px",
                  textAlign: "center",
                  color: "#2c3e50",
                }}
              >
                Secure Your Spot
              </h2>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057",
                  }}
                >
                  First Name *
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={inputs.firstName}
                  onChange={handleChange}
                  style={inputStyles}
                  onFocus={(e) =>
                    Object.assign(e.target.style, inputFocusStyles)
                  }
                  onBlur={(e) => Object.assign(e.target.style, inputStyles)}
                />
                {errors.firstName && (
                  <span style={errorStyles}>{errors.firstName}</span>
                )}
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057",
                  }}
                >
                  Last Name *
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={inputs.lastName}
                  onChange={handleChange}
                  style={inputStyles}
                  onFocus={(e) =>
                    Object.assign(e.target.style, inputFocusStyles)
                  }
                  onBlur={(e) => Object.assign(e.target.style, inputStyles)}
                />
                {errors.lastName && (
                  <span style={errorStyles}>{errors.lastName}</span>
                )}
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057",
                  }}
                >
                  Email Address *
                </label>
                <input
                  type="email"
                  name="email"
                  value={inputs.email}
                  onChange={handleChange}
                  style={inputStyles}
                  onFocus={(e) =>
                    Object.assign(e.target.style, inputFocusStyles)
                  }
                  onBlur={(e) => Object.assign(e.target.style, inputStyles)}
                />
                {errors.email && (
                  <span style={errorStyles}>{errors.email}</span>
                )}
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057",
                  }}
                >
                  Phone Number *
                </label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={inputs.phoneNumber}
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  placeholder="+27123456789"
                  style={inputStyles}
                  onFocus={(e) =>
                    Object.assign(e.target.style, inputFocusStyles)
                  }
                  onBlur={(e) => Object.assign(e.target.style, inputStyles)}
                />
                {errors.phoneNumber && (
                  <span style={errorStyles}>{errors.phoneNumber}</span>
                )}
              </div>

              <div style={checkboxContainerStyles}>
                <input
                  type="checkbox"
                  id="consent"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginTop: "2px",
                    cursor: "pointer",
                  }}
                />
                <label
                  htmlFor="consent"
                  style={{
                    color: "#6c757d",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  By signing up for and using Kago Events, you agree to the
                  collection, use, and sharing of your data as described in this
                  Data Usage Policy. Event entrance data will be sent to you via
                  email. Please be sure to check both your inbox and spam folder
                  to ensure you receive your event details.
                </label>
              </div>
              {errors.checkbox && (
                <span style={errorStyles}>{errors.checkbox}</span>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                style={submitButtonStyles}
                onMouseOver={(e) => {
                  if (!isSubmitting) {
                    e.target.style.backgroundColor = "#f48d2e";
                    e.target.style.transform = "translateY(-1px)";
                  }
                }}
                onMouseOut={(e) => {
                  if (!isSubmitting) {
                    e.target.style.backgroundColor = "#f48d2e";
                    e.target.style.transform = "translateY(0)";
                  }
                }}
              >
                {isSubmitting ? "Registering..." : "Register for Free Webinar"}
              </button>

              {submitSuccess && (
                <div
                  style={{
                    marginTop: "20px",
                    padding: "15px",
                    backgroundColor: "#d4edda",
                    border: "1px solid #c3e6cb",
                    borderRadius: "8px",
                    color: "#155724",
                    textAlign: "center",
                  }}
                >
                  ✅ Registration successful! Check your email for event
                  details.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          textAlign: "center",
          padding: "40px 20px",
        }}
      >
        <p style={{ fontSize: "1rem", margin: 0 }}>
          © 2024 Kago Events. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default Webinar;

